import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateSentNotification,
  DeleteSentNotification,
  fetchAllSentNotification,
  UpdateSentNotification,
} from "../redux/action/authAction";
import moment from "moment";
import { Formik } from "formik";
import { AddNotificationSchema } from "../layout/Schema";
import ErrorMessage from "../layout/ErrorMessage";
import Loader from "../components/other/Loader";
import NoRecord from "../components/other/NoRecord";
import ReactPagination from "../components/reactPagination";
import PaginationDropdown from "../components/PaginationDropdown";
import SegmentDropdown from "../components/form/SagmentDropdown";
import { pageRoutes } from "../routes/pageRoutes";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, isToggle, sentNotification } = useSelector(
    (state) => state.authReducer
  );
  const [errorObj, setErrorObj] = useState({
    sagment: "",
  });
  const [selectedSegment, setSelectedSegment] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const [AddNotification, SetNotification] = useState(false);
  const [editNotification, setEditNotification] = useState(false);
  const [filterNotification, setFilterNotification] = useState("");
  const [messageDetail, setMessageDetail] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [editNotifications, setEditNotifications] = useState();
  const initialState = {
    notification_title: "",
    notification_message: "",
    notification_scheduled_time: "",
    notification_scheduled_date: "",
  };
  useEffect(() => {
    dispatch(fetchAllSentNotification());
  }, []);

  const displayUsers = sentNotification
    ?.filter((item) => {
      return filterNotification != ""
        ? item?.is_sent == filterNotification
        : item;
    })
    .slice(currentPage * usersPerPage, (currentPage + 1) * usersPerPage);

  useEffect(() => {
    setMessageDetail(displayUsers[0] ?? {});
    if (displayUsers?.length == 0) {
      handleAddNotificationOpen();
    } else {
      handleCloseAddNotification();
    }
  }, [sentNotification]);

  const handleAddNotificationOpen = () => {
    setSelectedSegment("");
    setSelectedValue("");
    SetNotification(true);
  };
  const handleCloseAddNotification = () => {
    SetNotification(false);
  };
  const handleEditNotificationOpern = () => {
    setEditNotification(true);
  };
  const handleCloseEditNotification = () => {
    setEditNotification(false);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const createNotofication = async (values, { setSubmitting, resetForm }) => {
    if (!selectedSegment) {
      setErrorObj({ ...errorObj, sagment: "Please select segment" });
      return;
    }
    if (!selectedValue) {
      if (selectedSegment == "age")
        return setErrorObj({
          ...errorObj,
          [selectedSegment]: "Please select age",
        });
      else
        return setErrorObj({
          ...errorObj,
          [selectedSegment]: "Please select value",
        });
    }
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchAllSentNotification());
        handleCloseAddNotification();
        setSelectedSegment("");
        setSelectedValue("");
        setErrorObj();
        resetForm();
      }
    };
    const data = {
      notification_title: values?.notification_title,
      notification_message: values?.notification_message,
      notification_scheduled_time:
        values?.notification_scheduled_date +
        " " +
        values?.notification_scheduled_time,
      segment: selectedSegment,
      segment_value: selectedValue,
    };
    dispatch(CreateSentNotification({ payload: data, callback }));
  };

  const deleteNotification = (value) => {
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchAllSentNotification());
      }
    };
    dispatch(
      DeleteSentNotification({
        payload: { id: value?.notification_id },
        callback,
      })
    );
  };

  const updateNotification = async (values, { setSubmitting, resetForm }) => {
    if (!selectedSegment) {
      setErrorObj({ ...errorObj, sagment: "Please select segment" });
      return;
    }
    if (!selectedValue) {
      if (selectedSegment == "age")
        return setErrorObj({
          ...errorObj,
          [selectedSegment]: "Please select age",
        });
      else
        return setErrorObj({
          ...errorObj,
          [selectedSegment]: "Please select value",
        });
    }

    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchAllSentNotification());
        setSelectedSegment("");
        setSelectedValue("");
        setErrorObj();
        handleCloseEditNotification();
        setEditNotifications();
        resetForm();
      }
    };
    const data = {
      notification_id: values?.notification_id,
      notification_title: values?.notification_title,
      notification_message: values?.notification_message,
      notification_scheduled_time:
        values?.notification_scheduled_date +
        " " +
        values?.notification_scheduled_time,
      segment: selectedSegment,
      segment_value: selectedValue,
    };
    dispatch(UpdateSentNotification({ payload: data, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div className="ct_right_content">
          <Header />
          <div class="ct_right_header">
            <div class="ct_left_header_cnt">
              <div class="form-group">
                <label for="" class="mb-2 ct_fw_600">
                  Filter Notification By status
                </label>
                <select
                  class="form-control ct_input ct_pointer_curser"
                  value={filterNotification}
                  onChange={(e) => setFilterNotification(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="1">Sent</option>
                  <option value="0">Scheduled</option>
                </select>
              </div>
            </div>
            <div class="ct_right_header_left">
              <div class="ct_toggle_bar">
                <i class="fa-solid fa-bars"></i>
              </div>
            </div>
          </div>
          <div className="ct_inner_dashbaord_main">
            <div className="row ">
              <div className="col-xxl-9 col-xl-8 mb-4 mb-xl-0 ">
                <div className="ct_top_sticky">
                  <div className="">
                    <div className="d-flex align-items-center gap-3 justify-content-between ct_flex_column_767">
                      <ul className="d-flex align-items-center  gap-2 mb-0">
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            All Notification
                          </h4>
                        </li>
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            <i className="bi bi-dot"></i>
                          </h4>
                        </li>
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            {sentNotification?.length ?? 0} Notification{" "}
                          </h4>
                        </li>
                      </ul>
                      <button
                        className="ct_orange_btn ct_btn_h_44"
                        onClick={handleAddNotificationOpen}
                      >
                        + Create Notification
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table ct_custom_table">
                        <thead>
                          <tr>
                            <th className="ct_fw_600">S.No.</th>
                            <th>Title</th>
                            <th>Message</th>
                            <th>Sent Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayUsers && displayUsers?.length != 0 ? (
                            displayUsers?.map((item, i) => (
                              <tr
                                onClick={() => {
                                  setMessageDetail(item);
                                  handleAddNotificationOpen();
                                  handleCloseEditNotification();
                                  handleCloseAddNotification();
                                }}
                              >
                                <td>{i + 1}</td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    {item?.notification_title ?? ""}
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{
                                      whiteSpace: "normal",
                                      width: "300px",
                                    }}
                                  >
                                    {item?.notification_message
                                      ? `${item?.notification_message?.slice(
                                          0,
                                          30
                                        )}${
                                          item?.notification_message?.length >
                                          28
                                            ? "..."
                                            : ""
                                        }`
                                      : ""}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <p className="mb-0 ct_fs_16">
                                      <span>
                                        {moment(
                                          item?.notification_scheduled_time
                                        ).format("DD-MM-YYYY")}
                                      </span>
                                      <span className="ms-2">
                                        {moment(
                                          item?.notification_scheduled_time
                                        ).format("hh:mm A")}
                                      </span>
                                    </p>
                                  </div>
                                </td>
                                <td className="text-end">
                                  <div>
                                    <p className="mb-0 ct_fs_16 ct_red_text">
                                      {item?.is_sent == 1
                                        ? "Sent"
                                        : "Scheduled"}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7}>
                                <NoRecord />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <div>
                        <PaginationDropdown
                          onChange={(val) => {
                            setUserPerPages(val);
                            setCurrentPage(0);
                          }}
                        />
                      </div>
                      <div>
                        <ReactPagination
                          pageCount={Math.ceil(
                            sentNotification?.length / usersPerPage
                          )}
                          onPageChange={handlePageClick}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 mb-4 mb-xl-0">
                {displayUsers?.length != 0 && (
                  <div
                    className={
                      !AddNotification && !editNotification
                        ? "ct_top_sticky"
                        : "d-none"
                    }
                  >
                    <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0 text-center">
                      Notification Details
                    </h4>
                    <div className="ct_ride_side_sidebar ct_white_bg position-relative">
                      {/* Notification Detail S */}
                      <i
                        className="fa-solid fa-eye ct_notify_user_view"
                        onClick={() =>
                          navigate(pageRoutes?.notificationDetail, {
                            state: { messageDetail },
                          })
                        }
                      ></i>
                      <div className="ct_notifiication_detail_main ">
                        <div className="ct_notification_user_img text-center"></div>
                        <div className="mt-3">
                          <p className="mb-1 ct_text_op_50 ct_fw_600">Title </p>
                          <p className="mb-0 ct_fw_600">
                            {messageDetail?.notification_title ?? ""}
                          </p>
                        </div>
                        <div className="mt-3">
                          <p className="mb-1 ct_text_op_50 ct_fw_600">
                            Message{" "}
                          </p>
                          <p className="mb-0 ct_fw_600">
                            {messageDetail?.notification_message ?? ""}
                          </p>
                        </div>
                        <div className="mt-3">
                          <p className="mb-1 ct_text_op_50 ct_fw_600">
                            Sagment : Value{" "}
                          </p>
                          <p className="mb-0 ct_fw_600 text-capitalize">
                            {`${messageDetail?.segment ?? ""} : ${
                              messageDetail?.segment_value
                            }`}
                          </p>
                        </div>
                        <div className="mt-3">
                          <p className="mb-1 ct_text_op_50 ct_fw_600">
                            Date and Time{" "}
                          </p>
                          <span className="mb-0 ct_fw_600">
                            {moment(
                              messageDetail?.notification_scheduled_time
                            ).format("DD-MM-YYYY")}
                          </span>
                          <span className="ms-2 ct_fw_600">
                            {moment(
                              messageDetail?.notification_scheduled_time
                            ).format("hh:mm A")}
                          </span>
                        </div>
                        <div className="mt-3">
                          <p className="mb-1 ct_text_op_50 ct_fw_600">Status</p>
                          <p className="mb-0 ct_fw_600">
                            {messageDetail?.is_sent == 1 ? "Sent" : "Scheduled"}
                          </p>
                        </div>

                        <div className="mt-3">
                          <a
                            href="javascript:void(0)"
                            className="ct_orange_btn ct_btn_h_44 w-100 d-flex  align-items-center justify-content-center"
                            onClick={() => {
                              setEditNotifications({
                                notification_id: messageDetail?.notification_id,
                                notification_title:
                                  messageDetail?.notification_title ?? "",
                                notification_message:
                                  messageDetail?.notification_message ?? "",
                                notification_scheduled_date:
                                  messageDetail?.notification_scheduled_time
                                    ? moment(
                                        messageDetail.notification_scheduled_time
                                      ).format("YYYY-MM-DD")
                                    : "",

                                notification_scheduled_time:
                                  messageDetail?.notification_scheduled_time
                                    ? moment(
                                        messageDetail.notification_scheduled_time
                                      ).format("HH:mm")
                                    : "",
                              });
                              setSelectedSegment(messageDetail?.segment ?? "");

                              setSelectedValue(
                                messageDetail?.segment_value ?? ""
                              );

                              handleEditNotificationOpern();
                            }}
                          >
                            Edit
                          </a>
                          <button
                            className="ct_orange_btn ct_btn_h_44 w-100 ct_red_btn mt-3"
                            onClick={() => deleteNotification(messageDetail)}
                          >
                            Delete Notification
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Edit Notification Detail S */}
                <div
                  className={
                    editNotification && !AddNotification
                      ? " ct_top_sticky"
                      : "d-none ct_top_sticky"
                  }
                >
                  <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0 text-center">
                    Edit Notification
                  </h4>
                  <div className="ct_ride_side_sidebar ct_white_bg ">
                    {editNotifications && (
                      <Formik
                        initialValues={editNotifications}
                        validationSchema={AddNotificationSchema}
                        onSubmit={(values, actions) => {
                          updateNotification(values, actions);
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          resetForm,
                          handleSubmit,
                        }) => (
                          <form className="mt-4">
                            <div className="ct_notifiication_detail_main">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label for="" className="mb-2 ct_fw_600">
                                      Title
                                    </label>
                                    <input
                                      id="notification_title"
                                      type="text"
                                      className="form-control ct_input ct_fw_600"
                                      placeholder="Enter title"
                                      value={values.notification_title}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="notification_title"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label for="" className="mb-2 ct_fw_600">
                                      Message
                                    </label>
                                    <textarea
                                      id="notification_message"
                                      className="form-control ct_input ct_fw_600 h-auto"
                                      rows="4"
                                      placeholder="Enter message"
                                      value={values.notification_message}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                    ></textarea>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="notification_message"
                                    />
                                  </div>
                                </div>
                                {/* Sagement dropdown s */}
                                <SegmentDropdown
                                  errorObj={errorObj}
                                  selectedSegment={selectedSegment}
                                  setErrorObj={(val) => {
                                    setErrorObj(val);
                                  }}
                                  setSelectedSegment={(val) => {
                                    setSelectedValue("");
                                    setSelectedSegment(val);
                                  }}
                                  selectedValue={selectedValue}
                                  setSelectedValue={(val) => {
                                    setSelectedValue(val);
                                    setErrorObj({
                                      ...errorObj,
                                      [selectedSegment ?? "key"]: "",
                                    });
                                  }}
                                />
                                {/* Sagement dropdown e */}
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <input
                                      id="notification_scheduled_date"
                                      type="date"
                                      className="form-control ct_input ct_grey_input"
                                      style={{ backgroundColor: "#f2f2f2" }}
                                      value={values.notification_scheduled_date}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      min={
                                        new Date()?.toISOString()?.split("T")[0]
                                      }
                                      onKeyDown={(e) => e.preventDefault()}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="notification_scheduled_date"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <input
                                      id="notification_scheduled_time"
                                      onKeyDown={(e) => e.preventDefault()}
                                      type="time"
                                      className="form-control ct_input ct_grey_input"
                                      style={{ backgroundColor: "#f2f2f2" }}
                                      value={values.notification_scheduled_time}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      defaultValue={
                                        values.notification_scheduled_time
                                      }
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="notification_scheduled_time"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mt-3">
                              <button
                                type="button"
                                className="ct_orange_btn ct_btn_h_44 w-100"
                                onClick={handleSubmit}
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                className="ct_orange_btn ct_btn_h_44 w-100 ct_cancel_btn mt-3"
                                onClick={() => {
                                  handleCloseEditNotification();
                                  resetForm();
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </form>
                        )}
                      </Formik>
                    )}
                  </div>
                </div>

                {/* add Notification Detail S */}
                <div
                  className={
                    AddNotification ? "ct_top_sticky" : "d-none ct_top_sticky"
                  }
                >
                  <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0 text-center">
                    Create New Notification
                  </h4>
                  <div className="ct_ride_side_sidebar ct_white_bg ">
                    <Formik
                      initialValues={initialState}
                      validationSchema={AddNotificationSchema}
                      onSubmit={(values, actions) => {
                        createNotofication(values, actions);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        resetForm,
                        handleSubmit,
                      }) => (
                        <form className="mt-4">
                          <div className="ct_notifiication_detail_main">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group mb-3">
                                  <label for="" className="mb-2 ct_fw_600">
                                    Title
                                  </label>
                                  <input
                                    id="notification_title"
                                    type="text"
                                    className="form-control ct_input ct_fw_600"
                                    placeholder="Enter title"
                                    value={values.notification_title}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="notification_title"
                                  />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group mb-3">
                                  <label for="" className="mb-2 ct_fw_600">
                                    Message
                                  </label>
                                  <textarea
                                    id="notification_message"
                                    className="form-control ct_input ct_fw_600 h-auto"
                                    rows="4"
                                    placeholder="Enter message"
                                    value={values.notification_message}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  ></textarea>
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="notification_message"
                                  />
                                </div>
                              </div>
                              {/* Sagement dropdown s */}
                              <SegmentDropdown
                                errorObj={errorObj}
                                selectedSegment={selectedSegment}
                                setErrorObj={(val) => {
                                  setErrorObj(val);
                                }}
                                setSelectedSegment={(val) => {
                                  setSelectedValue("");
                                  setSelectedSegment(val);
                                }}
                                selectedValue={selectedValue}
                                setSelectedValue={(val) => {
                                  setSelectedValue(val);
                                  setErrorObj({
                                    ...errorObj,
                                    [selectedSegment ?? "key"]: "",
                                  });
                                }}
                              />
                              {/* Sagement dropdown e */}
                              <div className="col-md-6">
                                <div className="form-group mb-3">
                                  <input
                                    id="notification_scheduled_date"
                                    type="date"
                                    className="form-control ct_input ct_grey_input"
                                    style={{ backgroundColor: "#f2f2f2" }}
                                    value={values.notification_scheduled_date}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    min={
                                      new Date()?.toISOString()?.split("T")[0]
                                    }
                                    onKeyDown={(e) => e.preventDefault()}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="notification_scheduled_date"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group mb-3">
                                  <input
                                    id="notification_scheduled_time"
                                    onKeyDown={(e) => e.preventDefault()}
                                    type="time"
                                    className="form-control ct_input ct_grey_input"
                                    style={{ backgroundColor: "#f2f2f2" }}
                                    value={values.notification_scheduled_time}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="notification_scheduled_time"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mt-3">
                            <button
                              type="button"
                              className="ct_orange_btn ct_btn_h_44 w-100"
                              onClick={handleSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              className="ct_orange_btn ct_btn_h_44 w-100 ct_cancel_btn mt-3"
                              onClick={() => {
                                handleCloseAddNotification();
                                resetForm();
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Notifications;
